import { createSlice } from '@reduxjs/toolkit';

import {
    INIT_AUTH,
    INIT_AUTH_FAILURE,
    INIT_AUTH_SUCCESS,
    INVALID_PASSWORD,
    LOGIN_USER,
    LOGIN_USER_FAILURE,
    LOGIN_USER_SUCCESS,
    LOGOUT_USER,
    SHOW_SECOND_STEP_AUTH_FORM,
    SET_AUTH_VALUES,
    VALID_PASSWORD,
    RESEND_CODE,
    RESEND_CODE_SUCCESS,
    RESEND_CODE_FAILURE,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    initialValues: {
        email: null,
        password: null,
        code: null,
        validationToken: null,
    },
    initAuth: {
        isLoading: false,
        errors: null,
    },
    resendCode: {
        isLoading: false,
        errors: null,
    },
    session: {
        user: null,
        isLoading: false,
        errors: null,
    },
    validPassword: false,
    showSecondStepForm: false,
};

const loginSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [INIT_AUTH]: (state) => {
            state.initAuth.isLoading = true;
        },
        [INIT_AUTH_FAILURE]: (state, action) => {
            state.initAuth = {
                ...state.initAuth,
                isLoading: false,
                errors: action.payload,
            };
        },
        [INIT_AUTH_SUCCESS]: (state) => {
            state.initAuth.isLoading = false;
        },
        [LOGIN_USER]: (state) => {
            state.session.isLoading = true;
        },
        [LOGIN_USER_FAILURE]: (state, action) => {
            state.session = {
                ...state.session,
                isLoading: false,
                errors: action.payload,
            };
        },
        [LOGIN_USER_SUCCESS]: (state) => {
            state.session.isLoading = false;
        },
        [LOGOUT_USER]: (state) => {
            state.session = {
                ...state.session,
                user: null,
                isLoading: false,
                errors: null,
            };
        },
        [INVALID_PASSWORD]: (state) => {
            state.validPassword = false;
        },
        [RESEND_CODE]: (state) => {
            state.resendCode.isLoading = true;
        },
        [RESEND_CODE_FAILURE]: (state, action) => {
            state.resendCode = {
                ...state.resendCode,
                isLoading: false,
                errors: action.payload,
            };
        },
        [RESEND_CODE_SUCCESS]: (state, action) => {
            state.resendCode = {
                ...state.resendCode,
                data: action.payload,
                isEmpty: action.payload.length === 0,
                isLoading: false,
            };
        },
        [SHOW_SECOND_STEP_AUTH_FORM]: (state, action) => {
            state.showSecondStepForm = action.payload;
        },
        [SET_AUTH_VALUES]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [VALID_PASSWORD]: (state) => {
            state.validPassword = true;
        },
    },
});

export const loginActions = loginSlice.actions;

export default loginSlice.reducer;
